import { render, staticRenderFns } from "./debugging.vue?vue&type=template&id=41a34038&scoped=true"
import script from "./debugging.vue?vue&type=script&lang=js"
export * from "./debugging.vue?vue&type=script&lang=js"
import style0 from "./debugging.vue?vue&type=style&index=0&id=41a34038&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a34038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a34038')) {
      api.createRecord('41a34038', component.options)
    } else {
      api.reload('41a34038', component.options)
    }
    module.hot.accept("./debugging.vue?vue&type=template&id=41a34038&scoped=true", function () {
      api.rerender('41a34038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/courseTrain/meredu/components/debugging.vue"
export default component.exports